module.exports = __webpack_public_path__ + "static/media/load.43302795.svg";